export default {
      id: "3-2-usage",
      viewBox: "0 0 88 88",
      url: "assets/" + "sprite.svg#3-2-usage",
      toString: function () {
        return this.url;
      }
    }